// Mock data for The Corner Office Curmudgeon design showcase.
// NOTE: This is MOCK data for previewing designs only (no backend yet).
// The featured post is the real existing content from cornerofficecurmudgeon.com.
// The additional posts are SAMPLE placeholders so each design feels like a full blog.

export const HERO_IMAGE = "/hero.jpg";

export const brand = {
  name: "The Corner Office Curmudgeon",
  logoTop: "the",
  logoLine1: "CORNER OFFICE",
  logoLine2: "CURMUDGEON",
  tagline: "An incomplete archive of a blog I ran many moons ago.",
  copyright: "Copyright \u00A9 2026 Corner Office Curmudgeon \u2013 All Rights Reserved.",
  footerHeadline: "Don't Bother",
  footerSub: "I'm not taking subscriptions anyway",
};

export const featuredPost = {
  id: "art-of-selling",
  title: "The Art of Selling to C-Level Executives",
  subtitle: "Introduction",
  date: "From the archives",
  image: HERO_IMAGE,
  real: true,
  paragraphs: [
    "Well, Here it is. An incomplete archive of a blog I ran many moons ago.",
    "In that galaxy far away, I wrote a blog/column called \"The Corner Office Curmudgeon\" where I put on the hat of a rather impatient and sometimes short-tempered CEO who wanted to grumble about \"kids nowadays\" who don't understand that when you're selling to me as a C-Level executive. Tough love from a grizzled exec with the squint of Clint Eastwood and the snear of Billy Idol.",
    "I didn't care whether you admired my tie or the picture of my lovely wife (uh, that's my daughter) on the desk. I didn't want to hear the same old blah, blah, blah with the bloat and buzzwords that I heard from every salesperson and their dog.",
    "I wanted to know if you a) had any clue about what you were doing, b) understood and could address MY KPIs, and c) what did you want me to do about it and WHY.",
    "It was fun writing the articles, and I recently pulled them out again just for fun. I haven't found all of them yet (hope their on my old DC2000 tapes and Syquest backup drives), but I may start dropping them here when I come across them.",
    "So if you wander into this musty corner of the interwebs and want to poke the bear and tell me I'm wrong-- have at it. I think a lot of the underlying principles do still apply.",
    "Just Caveat Emptor. And remember I'm mostly just doing this for my own amusement...",
  ],
};

// SAMPLE placeholder posts (mock only) to fill the archive list in each design.
export const posts = [
  {
    id: "stop-features",
    title: "Stop Telling Me About Your Features",
    subtitle: "Nobody in this office cares about your feature list.",
    date: "Sample \u00B7 6 min read",
    image:
      "https://images.unsplash.com/photo-1619517934704-1613baa38c29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwyfHxncnVtcHklMjBleGVjdXRpdmV8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzg1MTc3NDcxfDA&ixlib=rb-4.1.0&q=85",
    excerpt:
      "You marched in here with forty-two slides of features and not one sentence about my business. Let me save us both some time...",
    mock: true,
  },
  {
    id: "my-kpis",
    title: "MY KPIs, Not Your Talking Points",
    subtitle: "Address my numbers or address the door.",
    date: "Sample \u00B7 5 min read",
    image:
      "https://images.unsplash.com/photo-1544717301-9cdcb1f5940f?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YW5ncnklMjBidXNpbmVzc21hbnxlbnwwfHwwfHx8MA%3D%3D",
    excerpt:
      "I have a board meeting on Thursday. Tell me how you move one of the three numbers I actually get graded on. I'll wait.",
    mock: true,
  },
  {
    id: "death-by-buzzword",
    title: "Death by Buzzword",
    subtitle: "If I hear 'synergy' one more time...",
    date: "Sample \u00B7 4 min read",
    image:
      "https://images.pexels.com/photos/8872593/pexels-photo-8872593.jpeg?cs=tinysrgb&dpr=2&h=650&w=940",
    excerpt:
      "Leverage. Synergy. Paradigm. Holistic. Say one more of those and I'm expensing the aspirin to your company.",
    mock: true,
  },
  {
    id: "thirty-second-rule",
    title: "The 30-Second Rule",
    subtitle: "You get half a minute. Make it count.",
    date: "Sample \u00B7 3 min read",
    image:
      "https://images.unsplash.com/photo-1494368308039-ed3393a402a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxncnVtcHklMjBleGVjdXRpdmV8ZW58MHx8fGJsYWNrX2FuZF93aGl0ZXwxNzg1MTc3NDcxfDA&ixlib=rb-4.1.0&q=85",
    excerpt:
      "My assistant gave you the meeting. I'm giving you thirty seconds. Waste them on pleasantries and we're done.",
    mock: true,
  },
];

export const designs = [
  {
    id: "classic",
    name: "Classic Curmudgeon",
    subtitle: "Your current look, cleaned up",
    accent: "#c0392b",
    description:
      "A faithful recreation of your existing site: full-width red logo header, centered Poppins headlines, Times New Roman body text on clean white. Familiar and unchanged.",
    swatches: ["#ffffff", "#1b1b1b", "#c0392b"],
  },
  {
    id: "editorial",
    name: "Modern Editorial",
    subtitle: "Magazine-style columns",
    accent: "#b03030",
    description:
      "A polished magazine feel: Playfair Display serif headlines, drop caps, a warm paper background and a refined single reading column with a bold red byline rule.",
    swatches: ["#f7f3ec", "#1a1a1a", "#b03030"],
  },
  {
    id: "dark",
    name: "Dark Newsroom",
    subtitle: "The dank corner of the crankynet",
    accent: "#e63946",
    description:
      "Charcoal background, condensed Oswald headlines and blood-red accents. Gritty and moody \u2014 matches the grumpy, after-hours tone of the column.",
    swatches: ["#141414", "#f5f5f5", "#e63946"],
  },
  {
    id: "minimal",
    name: "Minimal Reader",
    subtitle: "Distraction-free reading",
    accent: "#111827",
    description:
      "A calm, Medium-inspired layout: generous whitespace, Inter headings, comfortable Lora reading text and understated dividers. Content is the star.",
    swatches: ["#ffffff", "#111827", "#6b7280"],
  },
  {
    id: "vintage",
    name: "Vintage Typewriter",
    subtitle: "Straight off the DC2000 tapes",
    accent: "#a03626",
    description:
      "Aged paper texture, Special Elite typewriter headlines and Courier body copy with red stamp accents \u2014 a nod to a blog written many moons ago.",
    swatches: ["#efe7d3", "#2a241c", "#a03626"],
  },
];
